export class GetCommonPdfResponse {
    commonPdfUrl!: string
    commonPdfDownloadUrl!: string
}
